import React from "react";
import { createRoot } from "react-dom/client";
import Flow from "./flow/Flow";
import './css/stepProgress.scss';

const container = document.getElementById("registration-flow-inject");
if (container) {
  const root = createRoot(container);
  root.render(<Flow addNcf={ false } />);
}